module.exports = __webpack_public_path__ + "static/media/ESPIGA.fb81308a.png";